import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  SistemaCadastroDto,
  SistemaFiltrarDto,
  SistemaFiltrarSchema,
} from "./Sistema.Dto";
import { useToast } from "src/componentes";
import { useEffect, useState } from "react";
import { ConfiguracaoFiltrar } from "src/services/Fiscal.Service";
import { useSearchParams } from "react-router-dom";
import { MapearErrosServidor } from "src/hook/Functions";

const SistemaCode = () => {
  const [data, setData] = useState<SistemaCadastroDto[]>([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<SistemaFiltrarDto>({
    resolver: yupResolver(SistemaFiltrarSchema),
  });

  const [searchParams, setSearchParams] = useSearchParams();
  const [filtros, setFiltros] = useState<SistemaFiltrarDto>({
    subModulo: searchParams.get("subModulo") || "1",
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setLoading(true);
      await filtrar(filtros).finally(() => {
        setLoading(false);
      });
    };
    Load();

    return () => {
      controller.abort();
    };
  }, [filtros]);

  useEffect(() => {
    const novoFiltro: SistemaFiltrarDto = {
      subModulo: searchParams.get("subModulo") || "1",
    };

    setFiltros((prevFiltros) => {
      if (JSON.stringify(prevFiltros) === JSON.stringify(novoFiltro)) {
        return prevFiltros;
      }
      return novoFiltro;
    });
  }, [searchParams]);

  const filtrar = async (input: SistemaFiltrarDto) => {
    await ConfiguracaoFiltrar(input)
      .then((response) => {
        if (response.data.success) {
          setData(response.data.data);
        } else {
          MapearErrosServidor(response.data.notifications, showToast);
        }
      })
      .catch((error) => {
        showToast({
          message: "Ocorreu erro ao buscar dados",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      });
  };

  const handleSelect = (eventKey?: string | null) => {
    if (eventKey) {
      const novoFiltro = new URLSearchParams(searchParams);
      novoFiltro.set("subModulo", eventKey);
      setSearchParams(novoFiltro, { replace: true });
    }
  };

  return {
    data,
    loading,
    register,
    handleSubmit,
    filtros,
    errors,
    handleSelect,
  };
};

export default SistemaCode;
